import React from 'react';
import { Col, Input, Row, Form } from 'antd';
import { TitleLabel } from './styles';
const ModalEditarColeta: React.FC = () => {
  return (
    <>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <TitleLabel>Nome do cliente:</TitleLabel>
          <Form.Item name="NomedoCliente">
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col md={12} sm={24} xs={24}>
          <TitleLabel>Nome transportadora:</TitleLabel>
          <Form.Item name="NomeTransportadora">
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col md={12} sm={24} xs={24}>
          <TitleLabel>Destino:</TitleLabel>
          <Form.Item name="Destino">
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col md={12} sm={24} xs={24}>
          <TitleLabel>Peso Bruto:</TitleLabel>
          <Form.Item name="peso">
            <Input type="text" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default ModalEditarColeta;
